// extracted by mini-css-extract-plugin
export default {"button":"AiImageGenerationEntryButton__button--PQBqF","text":"AiImageGenerationEntryButton__text--28ph9"};